import { ActivationMissingActions } from 'constants/ActionsTypesTs'
import {
	ICancelMissingOrdersAction,
	ICancelMissingOrdersActionSuccess,
	ICancelMissingOrdersParams,
	ICancelMissingOrdersResponse,
	IConfirmMissingOrdersAction,
	IConfirmMissingOrdersActionSuccess,
	IConfirmMissingOrdersParams,
	IConfirmMissingOrdersResponse,
	IConfirmMissingOrdersStatusAction,
	IConfirmMissingOrdersStatusActionSuccess,
	IConfirmMissingOrdersStatusParams,
	IConfirmMissingOrdersStatusResponse,
	IGetActivationMissingOrdersAction,
	IGetActivationMissingOrdersActionSuccess,
	IGetActivationMissingOrdersParams,
	IGetActivationMissingOrdersResponse,
	ISelectActivationMissingItemAction,
	ISelectActivationMissingItemActionSuccess,
	ISelectActivationMissingItemParams,
	ISelectActivationMissingItemResponse
} from 'models/ActivationMissingOrders'

export const getActivationMissingOrders = (
	payload: IGetActivationMissingOrdersParams
): IGetActivationMissingOrdersAction => ({
	type: ActivationMissingActions.GET_ACTIVATION_MISSING_ORDERS,
	payload
})

export const getActivationMissingOrdersSuccess = (
	payload: IGetActivationMissingOrdersResponse
): IGetActivationMissingOrdersActionSuccess => ({
	type: ActivationMissingActions.GET_ACTIVATION_MISSING_ORDERS_SUCCESS,
	payload
})

export const selectActivationMissingItem = (
	payload: ISelectActivationMissingItemParams
): ISelectActivationMissingItemAction => ({
	type: ActivationMissingActions.SELECT_ACTIVATION_MISSING_ITEM,
	payload
})

export const selectActivationMissingItemSuccess = (
	payload: ISelectActivationMissingItemResponse
): ISelectActivationMissingItemActionSuccess => ({
	payload,
	type: ActivationMissingActions.SELECT_ACTIVATION_MISSING_ITEM_SUCCESS
})

export const confirmActivationMissingOrders = (
	payload: IConfirmMissingOrdersParams
): IConfirmMissingOrdersAction => ({
	payload,
	type: ActivationMissingActions.CONFIRM_ACTIVATION_MISSING_ITEMS
})

export const confirmActivationMissingOrdersSuccess = (
	payload: IConfirmMissingOrdersResponse
): IConfirmMissingOrdersActionSuccess => ({
	payload,
	type: ActivationMissingActions.CONFIRM_ACTIVATION_MISSING_ITEMS_SUCCESS
})

export const confirmActivationMissingStatus = (
	payload: IConfirmMissingOrdersStatusParams
): IConfirmMissingOrdersStatusAction => ({
	payload,
	type: ActivationMissingActions.CONFIRM_ACTIVATION_MISSING_STATUS
})

export const confirmActivationMissingStatusSuccess = (
	payload: IConfirmMissingOrdersStatusResponse
): IConfirmMissingOrdersStatusActionSuccess => ({
	payload,
	type: ActivationMissingActions.CONFIRM_ACTIVATION_MISSING_STATUS_SUCCESS
})

export const confirmActivationMissingStatusClear = () => ({
	type: ActivationMissingActions.CONFIRM_ACTIVATION_MISSING_STATUS_CLEAR
})

export const cancelActivationMissingOrders = (
	payload: ICancelMissingOrdersParams
): ICancelMissingOrdersAction => ({
	type: ActivationMissingActions.CANCEL_ACTIVATION_MISSING,
	payload
})

export const cancelActivationMissingOrdersSuccess = (
	payload: ICancelMissingOrdersResponse
): ICancelMissingOrdersActionSuccess => ({
	type: ActivationMissingActions.CANCEL_ACTIVATION_MISSING_SUCCESS,
	payload
})
